<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Geräteübersicht für"}} {{company.name}}</h4>
		{{#if billing}}<h5>{{TIMEFORMAT billing.0.time_stamp "MMMM YYYY"}}</h5>{{/if}}
	</div>
</div>

{{#if stats}}
<div class="row p-b-10">
	<div class="col-xs-12">
		{{TR "Für den aktuellen Monat werden die folgenden Geräte in Rechnung gestellt:"}}
	</div>
</div>
<div class="row">
	{{#each stats}}
	<div class="col-md-6 col-lg-4">
		<div class="widget-bg-color-icon card-box">
			<div class="bg-icon bg-icon-success pull-left">
				<i class="{{icon}} text-success"></i>
			</div>
			<div class="text-right">
				<h3 class="text-dark"><b class="counter{{#if ../isInvoice}} invoice{{/if}}">{{name}}</b></h3>
				<h3 class="text-muted"><b>{{count}}</b></h3>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
	{{/each}}
</div>
{{else}}
<div class="alert alert-warning">
	<strong>{{TR "Es sind noch keine kostenpflichtige Geräte im Portal registriert."}}</strong>
</div>
{{/if}}
